<template element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" v-loading="loading">
	<div id="app">
		<keep-alive>
			<router-view v-if="$route.meta.keepAlive"></router-view>
		</keep-alive>
		<router-view v-if="!$route.meta.keepAlive"></router-view>
	</div>
</template>

<script>
import {} from '@/api/home'
export default {
	data() {
		return {}
	},
	watch: {},
	methods: {
		
    
	},
	components: {
		// 声明子组件名字
	},
	created() {},
	computed: {},
	mounted() {
	},
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/App.vue